export class ScrollToTopModule {

	constructor() {
		this.button = document.querySelector("[data-scroll-to-top]");

		if (this.button) {
			this.button.addEventListener('click', this.scrollToTop);
		}
	}

	scrollToTop() {
		window.scrollTo({top: 0, behavior: 'smooth'});
	}
}
